import { BaseService } from "./BaseService";
import { FunctionGroup, MeasuresType } from "../types/app.enums";
import { Measures } from "../types/app.interfaces";

export class PercentRankMeasuresService extends BaseService {
  burgissUniverseCalcIRRPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.IRRPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRRPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcIRR_QTDPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_QTDPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_QTDPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcIRR_YTDPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_YTDPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_YTDPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcIRR_1YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_1YearPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_1YearPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcIRR_3YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_3YearPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_3YearPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcIRR_5YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_5YearPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_5YearPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcIRR_10YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_10YearPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_10YearPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcIRR_15YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_15YearPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_15YearPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcIRR_20YearPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.IRR_20YearPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcIRR_20YearPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcDPIPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.DPIPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcDPIPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcRVPIPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.RVPIPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcRVPIPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcTVPIPercentRank(
    peergroupID: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peergroupID,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.TVPIPercentRank,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcTVPIPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }

  burgissUniverseCalcValuationPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.VALUATION_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcValuationPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  burgissUniverseCalcMIRRPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      MeasuresType.MIRR_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcMIRRPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  burgissUniverseCalcRIRRPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.RIRR_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcRIRRPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  burgissUniverseCalcDistributionsPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.DISTRIBUTIONS_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcDistributionsPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  burgissUniverseCalcNetCashFlowPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.NETCASHFLOW_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcNetCashFlowPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  burgissUniverseCalcPaidInCapitalPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      null,
      returnConstituentCount,
      filter,
      MeasuresType.PAIDINCAPITAL_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcPaidInCapitalPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  burgissUniverseCalcGGS_DirectAlphaPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      MeasuresType.GSS_DIRECTALPHA_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcGGS_DirectAlphaPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  burgissUniverseCalcKS_PMEPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      MeasuresType.KS_PME_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcKS_PMEPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  burgissUniverseCalcLN_ICMIRRPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMIRR_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMIRRPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  burgissUniverseCalcLN_ICMIRRSpreadPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMIRRSPREAD_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMIRRSpreadPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  burgissUniverseCalcLN_ICMValuationSpreadPercentRank(
    peerGroupId: any[][],
    value: any,
    currency: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      peerGroupId,
      value,
      currency,
      endDate,
      index,
      returnConstituentCount,
      filter,
      MeasuresType.LN_ICMVALUATIONSPREAD_PERCENTRANK,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseCalcLN_ICMValuationSpreadPercentRank",
      objRequest,
      this.APICONFIG.GETUA,
      FunctionGroup.PercentRankMeasures
    );
  }
  createPayload(
    peerGroupId: any[][] = null,
    value: any = null,
    currency: string = null,
    endDate: any = null,
    index: any = null,
    returnConstituentCount: any = null,
    filter: any = "",
    measure: string = null,
    alias: string = null
  ) {
    filter = "ExcelDna.Integration.ExcelMissing";
    const measuresObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: String(peerGroupId).toUpperCase() == "ALL" ? "-1" : String(peerGroupId),
      percentile: null,
      currency: null,
      returnConstituentCount: returnConstituentCount,
      investmentID: null,
      portfolioID: null,
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: String(currency).toLowerCase() === "true",
      alternateBaseCurrency: null,
      attributeName: null,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: null,
      endDate: endDate,
      year: null,
      indexID: index,
      premium: null,
      idType: null,
      selectionsetID: null,
      assetID: null,
      weightingMethod: null,
      value: value,
      filter: filter,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: 0,
      alias: alias,
      currencyHedgesetId: null,
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: null,
      universe: null,
      weight: null,
      commitment: null,
    };
    return measuresObject;
  }
}
